import { Theme } from "@mui/material/styles";
import SysRecord from "app/class/record";

type ActionStyle = "primary" | "secondary" | "success" | "warning" | "error" | "info" | "inherit";

const ACTION_STYLES = ["primary", "secondary", "success", "warning", "error", "info", "inherit"];

export const getActionStyle = (action?: SysRecord | null): ActionStyle => {
    const style = String(action?.action_style || "primary").toLowerCase();

    if (style === "danger" || style === "alert") {
        return "error";
    }

    return ACTION_STYLES.includes(style) ? style as ActionStyle : "primary";
};

export const getActionMuiColor = (action?: SysRecord | null): ActionStyle => getActionStyle(action);

const getPaletteColor = (theme: Theme, action?: SysRecord | null) => {
    const style = getActionStyle(action);

    if (style === "inherit") {
        return {
            main: theme.palette.text.primary,
            dark: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[300],
            contrastText: theme.palette.background.paper,
        };
    }

    return theme.palette[style];
};

export const getActionButtonSx = (action?: SysRecord | null) => (theme: Theme) => {
    const palette = getPaletteColor(theme, action);

    return {
        backgroundColor: palette.main,
        color: palette.contrastText,
        borderColor: palette.dark,
        "&:hover": {
            backgroundColor: palette.dark,
            boxShadow: "none",
        },
        "&.Mui-disabled": {
            backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[300],
            color: theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.grey[800],
            opacity: 1,
        },
    };
};

export const getActionIconSx = (action?: SysRecord | null) => (theme: Theme) => ({
    color: getPaletteColor(theme, action).main,
});
